


































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AuditKebersihanAlatService from "@/services/AuditKebersihanAlatService";
import {
  KRITERIA_AUDIT_KEBERSIHAN_ALAT,
  KAK_ITEM_COUNT,
  KriteriaAuditKebersihanAlat
} from "@/constants/kriteriaAuditKebersihanAlat";

type Penilaian = "ya" | "tidak" | "na" | null;

interface ResponseRow {
  id?: number;
  kriteria_no: number;
  penilaian: Penilaian;
  catatan: string;
}

@Component
export default class AuditKebersihanAlatKriteriaLogger extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  sessionNomor = "";
  kriteriaList = KRITERIA_AUDIT_KEBERSIHAN_ALAT;
  itemCount = KAK_ITEM_COUNT;

  responseMap: Record<number, ResponseRow> = {} as any;

  saving = false;
  submitting = false;
  submitDialog = false;
  submitForm: any = { password: "" };
  dirty = false;

  async mounted() {
    await this.loadSession();
    this.initResponses();
  }

  async loadSession() {
    const res = await AuditKebersihanAlatService.find(this.sessionId);
    this.session = res.data.data;
    this.sessionNomor = this.session.nomor_formulir;
  }

  initResponses() {
    const existing: Record<number, any> = {};
    (this.session.responses || []).forEach((r: any) => {
      existing[r.kriteria_no] = r;
    });
    this.kriteriaList.forEach(k => {
      const e = existing[k.no];
      this.$set(this.responseMap, k.no, {
        id: e?.id,
        kriteria_no: k.no,
        penilaian: (e?.penilaian as Penilaian) ?? null,
        catatan: e?.catatan || ""
      });
    });
  }

  // Tampilkan header grup sebelum item pertama yang punya kelompok.
  showGroupHeader(k: KriteriaAuditKebersihanAlat): boolean {
    if (!k.kelompok) return false;
    const idx = this.kriteriaList.findIndex(x => x.no === k.no);
    const prev = idx > 0 ? this.kriteriaList[idx - 1] : null;
    return !prev || prev.kelompok !== k.kelompok;
  }

  setPenilaian(k: number, v: "ya" | "tidak") {
    // Toggle: if already this value, clear to null
    if (this.responseMap[k].penilaian === v) {
      this.responseMap[k].penilaian = null;
    } else {
      this.responseMap[k].penilaian = v;
    }
    this.markDirty();
  }

  clearAllPenilaian() {
    this.kriteriaList.forEach(k => {
      this.responseMap[k.no].penilaian = null;
    });
    this.markDirty();
  }

  markDirty() {
    this.dirty = true;
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  get filledCount(): number {
    return Object.values(this.responseMap).filter(r => r.penilaian).length;
  }

  get totalPatuh(): number {
    return Object.values(this.responseMap).filter(r => r.penilaian === "ya").length;
  }

  get totalTidak(): number {
    return Object.values(this.responseMap).filter(r => r.penilaian === "tidak").length;
  }

  get overallRate(): number | null {
    const denom = this.totalPatuh + this.totalTidak;
    return denom > 0 ? Math.round((this.totalPatuh / denom) * 10000) / 100 : null;
  }

  get overallLabel(): string {
    const r = this.overallRate;
    if (r === null) return "Belum dinilai";
    if (r >= 85) return "BAIK";
    if (r >= 76) return "CUKUP";
    return "KURANG";
  }

  get overallColor(): string {
    const r = this.overallRate;
    if (r === null) return "grey";
    if (r >= 85) return "success";
    if (r >= 76) return "warning";
    return "error";
  }

  get canSubmit(): boolean {
    return this.filledCount > 0 && !this.dirty;
  }

  async saveAll() {
    this.saving = true;
    try {
      const responses = Object.values(this.responseMap).map(r => ({
        kriteria_no: r.kriteria_no,
        penilaian: r.penilaian,
        catatan: r.catatan
      }));
      await AuditKebersihanAlatService.bulkResponses(this.sessionId, responses);
      this.dirty = false;
      await this.loadSession();
      this.initResponses();
    } finally {
      this.saving = false;
    }
  }

  openSubmitDialog() {
    this.submitForm = { password: "" };
    this.submitDialog = true;
  }

  async confirmSubmit() {
    this.submitting = true;
    try {
      await AuditKebersihanAlatService.submitAuditor(this.sessionId, this.submitForm);
      this.submitDialog = false;
      this.$emit("submitted");
    } finally {
      this.submitting = false;
    }
  }
}
